<script>
export default {
  name: 'VNodes',
  props: {
    vnodes: [Object, String, Number],
  },
  setup(props) {
    return () => props.vnodes ?? '';
  },
};
</script>
